// extracted by mini-css-extract-plugin
export var boxItems = "_96-1";
export var boxItemsLg = "_96-2";
export var button = "_96-7";
export var buttonHoverless = "_96-9";
export var buttonLg = "_96-8";
export var filterGroupBox = "_96-0";
export var icon = "_96-3";
export var iconSecondary = "_96-6";
export var iconWrapper = "_96-4";
export var iconWrapperLg = "_96-5";
export var truncatedLabel = "_96-a";